import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qnhns74hec: FaireBrandEntity = {
  token: "b_qnhns74hec",
  type: "brand",
  name: "Botanopia USA - gifts , decor and cards for plant lovers",
  avatarUrl:
    "https://cdn.faire.com/fastly/d557186f6c5fff5db4cfebce1ce48662b73044b3a3ed78267647ed6c4dc4c8c1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/864936cdd3047d8bbadc24541ee5bcb74c3ff8c0f0e524f40151ad92fb674b46.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d557186f6c5fff5db4cfebce1ce48662b73044b3a3ed78267647ed6c4dc4c8c1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/864936cdd3047d8bbadc24541ee5bcb74c3ff8c0f0e524f40151ad92fb674b46.jpeg",
  location: "Middeltown, DE, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 44,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Botanopia USA!\n\nWe’re a young brand designing products out of our love for all growing things, operating from Amsterdam, the Netherlands. We celebrate the beauty of nature and the magical force that transforms small seeds into giant trees.\n\nWe started in 2017 with a porcelain accessory that lets you easily grow small trees and plants in your favorite glass or vase. It sits on top of the glass opening and lets the seeds or cuttings hover just above the water level, so they can grow roots without rotting.\n\nThe white surface acts as a picture frame to shine the spotlight on your growing seedlings.\n\nSince then, we’ve continued to design and produce smart and stylish solutions for plant lovers. From modern plant stakes to support your plants in style, to tiny accessories to create a miniature universe in your plants.\n\nWe also stock the tools and supplies that will help you take care of your plants: the best organic plant food, safe for plant cuttings, potting tarps for easy cleanup, and clever hanging systems to create lush plant walls.\n\nWe’re constantly developing and adding new products to elevate your plant life.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:22.722Z",
    importedBy: "entity-db-cli",
  },
};
